<template>
  <div id="recommendations" class="p-4">
    <div class="row align-items-center align-item-middle pb-4">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <h3 class="mb-0">Recommendations</h3>
        <div class="text-right">
          <a href="javascript:"  class="btn btn-secondary btn-sm"
              v-if="country == 'UK'"
              @click="showQuickRecommendationModal = true">
              <i class="fa-light fa-squirrel"></i> Send recommendations
          </a>
          <a href="javascript:"  class="btn btn-primary btn-sm "
              @click="showSendBrochuresModal = true">
              Send Brochures
          </a>
          <router-link
            :to="{ name: 'KarenV2Listing', params: { 'id': leadEvent.lead_id, 'eventId': leadEvent.id } }"
            class="btn btn-sm btn-primary karen-link"
          >
            KAREN
          </router-link>
          <router-link
            :to="{ name: 'LeadEventRecommendation', params: { 'id': leadEvent.lead_id, 'eventId': leadEvent.id } }"
            class="btn btn-sm btn-primary add-recommendation-link"
          >
            + Add
          </router-link> 
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <venue-recommendation
          :lead-event="leadEvent"
        ></venue-recommendation>
      </div>
    </div>
    <el-dialog
        title="Send Brochures"
        width="50%"
        :visible.sync="showSendBrochuresModal"
        v-if="showSendBrochuresModal"
        :close-on-click-modal="false"
        :append-to-body="true"
    >
        <SendBrochureRequestEmail :lead-event-id="leadEvent.id" @close="showSendBrochuresModal = false"/>
    </el-dialog>
    <el-dialog
        title="Send Recommendations"
        width="70%"
        :visible.sync="showQuickRecommendationModal"
        v-if="showQuickRecommendationModal"
        :close-on-click-modal="false"
        :append-to-body="true"
        center
    >
        <SendQuickRecommendation :lead-event-id="leadEvent.id" @close="showQuickRecommendationModal = false"/>
    </el-dialog>
  </div>
</template>
<script>
import VenueRecommendation from '@/views/Widgets/LeadEventDetails/VenueRecommendation';
import SendBrochureRequestEmail from '@/views/Widgets/BrochureRequestEmail/SendBrochureRequestEmail';
import SendQuickRecommendation from '@/views/Widgets/Recommendations/SendQuickRecommendation';
import recommendationMixin from "@/helpers/recommendationMixin";
import { Dialog } from "element-ui";
import { mapState } from "vuex";
export default {
  mixins: [recommendationMixin],
  components: {
    VenueRecommendation,
    SendBrochureRequestEmail,
    SendQuickRecommendation,
    [Dialog.name]: Dialog,
  },
  props: {
    leadEvent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      recommendationPortalLoading: false,
      showQuickRecommendationModal: false,
      showSendBrochuresModal: false
    };
  },
  computed: {
    ...mapState("country/", {
      country: (state) => state.country,
    }),
  },
};
</script>